import { useFormContext } from '@/providers';
import React, { useEffect, useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const PhoneNumberInput = ({ name, label, defaultCountry = 'US', defaultValue = '' }) => {
    const { register, setValue, getValues, watch, errors } = useFormContext();
    const fieldRefs = useRef({});
    const [phoneValue, setPhoneValue] = useState('');

    // Clean the phone number to E.164 format
    const cleanPhoneNumber = (number) => {
        if (!number) return '';
        // Remove all non-digit characters except +
        return number.replace(/[^\d+]/g, '');
    };

    // Set initial value when form context is ready
    useEffect(() => {
        const initialValue = cleanPhoneNumber(defaultValue || getValues(name)) || '';
        setPhoneValue(initialValue);
        setValue(name, initialValue, { shouldValidate: true });
    }, [getValues, name, setValue, defaultValue]);

    // Watch for changes in the phone number field
    const phoneNumber = watch(name);

    // Update local state when form value changes
    useEffect(() => {
        if (phoneNumber !== phoneValue) {
            setPhoneValue(cleanPhoneNumber(phoneNumber) || '');
        }
    }, [phoneNumber]);

    return (
        <div ref={(el) => (fieldRefs.current[name] = el)}>
            <label className="block text-sm font-medium">{label}</label>
            <PhoneInput
                {...register(name)}
                international
                defaultCountry={defaultCountry}
                value={phoneValue}
                onChange={(value) => {
                    const newValue = cleanPhoneNumber(value) || '';
                    setPhoneValue(newValue);
                    setValue(name, newValue, { shouldValidate: true });
                }}
                className="w-full p-2 border rounded-md"
                placeholder="Enter phone number"
            />
            {errors[name] && (
                <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">
                    {errors[name].message}
                </span>
            )}
        </div>
    );
};

export default PhoneNumberInput;